import React from "react";
import { connect } from "react-redux";
import { Row, Col, Accordion } from "react-bootstrap";
import ReactQuill from "react-quill-new";

import { format as formatDate } from "../../utils/date";
import { format as formatTime } from "../../utils/time";
import { open as openFile } from "../../actions/files";

import ConditionalButton from "../conditional-button";

import "../../css/accordion.css";
import 'react-quill-new/dist/quill.snow.css';

class Logs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: ""
        };
    }

    textHasContent = (text) => {
        const normalized = String(text || "")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

        return normalized.length > 0;
    };

    get has() {
        return this.props?.logs?.length > 0;
    }

    onTextChange = (e) => {
        this.setState({
            text: e
        }, () => {
            this.props.onPendingChange?.(this.hasPendingText());
        });
    };

    getPendingText = () => {
        return this.state.text;
    };

    hasPendingText = () => {
        return this.textHasContent(this.state.text);
    };

    clearPendingText = () => {
        this.setState({
            text: ""
        }, () => {
            this.props.onPendingChange?.(false);
        });
    };

    onAddClick = (e) => {
        if (this.props.onSave) this.props.onSave( this.state.text );
        this.clearPendingText();
    }

    onBodyClick = async (event) => {
        const anchor = event.target?.closest?.("a[data-file-uuid]");
        if (!anchor) return;

        event.preventDefault();
        const uuid = anchor.getAttribute("data-file-uuid");
        const name = anchor.getAttribute("data-file-name") || anchor.textContent || "file";

        if (uuid && this.props.openFile) {
            await this.props.openFile({ uuid, name });
        }
    };

    render() {
        return (
            <>
                <Row className="g-3" style={{marginTop: "10px"}}>
                    <Col lg="12">
                        <ReactQuill
                            name="text"
                            value={this.state?.text}
                            onChange={this.onTextChange}
                            style={{ height: "200px" }}
                        />
                    </Col>
                    <Col lg="12" style={{ marginTop: "75px" }}>
                        <ConditionalButton enabledVariant="outline-primary" display={true} enabled={true} onEnabledClick={this.onAddClick} icon="plus">Add</ConditionalButton>
                    </Col>
                </Row>
                <Row className="g-3">
                    <Col lg="12">
                        <Accordion
                            className="col-12 mt-4"
                            style={{ marginBottom: "25px" }}
                        >
                            {this.props?.logs?.map((log) => (
                                <Accordion.Item
                                    eventKey={log.uuid}
                                    key={`log_accordion_item_${log.uuid}`}
                                    className="col-12 pt-2 pl-3"
                                    style={{ paddingLeft: "20px" }}
                                >
                                    <Accordion.Header>{`${formatDate(log.createdAt ?? new Date())} ${formatTime(
                                        log.createdAt ?? new Date()
                                    )} by ${log.Author.firstName} ${log.Author.lastName
                                        }`}</Accordion.Header>
                                    <Accordion.Body
                                        onClick={this.onBodyClick}
                                        dangerouslySetInnerHTML={{ __html: log.meta }}
                                    ></Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </>
        )
    }
}

export default connect(null, { openFile })(Logs);
